import React from 'react';
import Header from './ContactUsHeader';
import Text from '@/presentation/text';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMessagesQuestion, faUserHeadset, faEarthAsia } from '@fortawesome/pro-light-svg-icons';
import {
  SHeader,
  SWrapper,
  SGridWrapper,
  SGridLayoutItemSmallPanel,
  SGridLayoutWrapper,
  SGridLayoutItemLargePanel,
} from './styles/HelpDesk.styled';
import { GridLayoutItem } from '@progress/kendo-react-layout';

const ContactUsSub: React.FC = () => {
  return (
    <SWrapper>
      <SHeader>
        <Header />
      </SHeader>
      <SGridWrapper>
        <SGridLayoutWrapper
          gap={{ rows: 1, cols: 3 }}
          rows={[
            {
              height: '50%',
            },
          ]}
          cols={[
            {
              width: '25%',
            },
            {
              width: '25%',
            },
            {
              width: '50%',
            },
          ]}
        >
          <SGridLayoutItemSmallPanel row={1} col={1}>
            <FontAwesomeIcon
              id="lnkSalesMktg"
              icon={faMessagesQuestion}
              title="Sales and Marketing"
              size="3x"
              color="#457387"
              style={{ paddingLeft: '40px', paddingTop: '40px', paddingBottom: '20px' }}
            />
            <Text size="s" id="idSalesMktg" weight="bold">
              Sales and Marketing
            </Text>
            <Text size="xs" id="idSalesMktgText" style={{ paddingTop: '12px' }}>
              Contact our Sales and Marketing team by phone or email:
            </Text>
            <Text size="xs" id="idSalesMktgPh" style={{ paddingTop: '12px' }}>
              <b>Phone</b> 303-200-2000
            </Text>
            <Text size="xs" id="idSalesMktgEmail">
              <b>Email</b> SalesOutputSolutions@csgi.com
            </Text>
          </SGridLayoutItemSmallPanel>
          <SGridLayoutItemSmallPanel row={1} col={2}>
            <FontAwesomeIcon
              id="lnkSupport"
              icon={faUserHeadset}
              title="Support"
              size="3x"
              color="#457387"
              style={{ paddingLeft: '40px', paddingTop: '40px', paddingBottom: '20px' }}
            />
            <Text size="s" id="idSupport" weight="bold">
              Support
            </Text>
            <Text size="xs" id="idSupportContcatText" style={{ paddingTop: '12px' }}>
              Contact your CSG Customer Delivery Manager or the Global Service Desk (GSD):
            </Text>
            <Text size="xs" id="idSupportPh" style={{ paddingTop: '12px' }}>
              <b>Phone</b> 888-275-1274
            </Text>
          </SGridLayoutItemSmallPanel>
          <SGridLayoutItemLargePanel row={1} col={3}>
            <FontAwesomeIcon
              id="lnkLocations"
              icon={faEarthAsia}
              title="Locations"
              size="3x"
              color="#457387"
              style={{ paddingLeft: '40px', paddingTop: '40px', paddingBottom: '20px' }}
            />
            <Text size="s" id="idLocations" weight="bold">
              Locations
            </Text>
            <SGridLayoutWrapper gap={{ rows: 1, cols: 3 }}>
              <GridLayoutItem row={1} col={1}>
                <Text size="xs" id="idNE" weight="bold" style={{ paddingTop: '12px' }}>
                  Design and Delivery Center (OMA DDC)
                </Text>
                <Text size="xs" id="idNEAddr1">
                  14301 Chandler Road
                </Text>
                <Text size="xs" id="idNEAddr2">
                  Omaha, NE 68138
                </Text>
                <Text size="xs" id="idNEAddr3">
                  USA
                </Text>
                <Text size="xs" id="idNEPh" style={{ paddingTop: '12px' }}>
                  <b>Phone</b> 402-431-7000
                </Text>
              </GridLayoutItem>
              <GridLayoutItem row={1} col={2}>
                <Text size="xs" id="idFL" weight="bold" style={{ paddingTop: '12px' }}>
                  Design and Delivery Center (FL DDC)
                </Text>
                <Text size="xs" id="idFLAddr1">
                  509 Commerce Blvd.
                </Text>
                <Text size="xs" id="idFLAddr2">
                  Crawfordville, FL 32327
                </Text>
                <Text size="xs" id="idFLAddr3">
                  USA
                </Text>
                <Text size="xs" id="idFLPh" style={{ paddingTop: '12px' }}>
                  <b>Phone</b> 850-402-6700
                </Text>
                <Text size="xs" id="idFLEmail">
                  <b>Fax</b> 850-402-6706
                </Text>
              </GridLayoutItem>
              <GridLayoutItem row={1} col={3}>
                <Text size="xs" id="idTX" weight="bold" style={{ paddingTop: '12px' }}>
                  Design and Delivery Center (FTW DDC)
                </Text>
                <Text size="xs" id="idTXAddr2">
                  2121 Providence Drive, Suite 151
                </Text>
                <Text size="xs" id="idTXAddr3">
                  Fort Worth, TX 76106
                </Text>
                <Text size="xs" id="idTXddr4">
                  USA
                </Text>
                <Text size="xs" id="idTXPh" style={{ paddingTop: '12px' }}>
                  <b>Phone</b> 682-268-6000
                </Text>
              </GridLayoutItem>
            </SGridLayoutWrapper>
          </SGridLayoutItemLargePanel>
        </SGridLayoutWrapper>
      </SGridWrapper>
    </SWrapper>
  );
};

export default ContactUsSub;
